{
  "email": "Email",
  "emailAddress": "Địa chỉ Email",
  "emailAddressPlaceholder": "Nhập địa chỉ Email của bạn",
  "continue": "Tiếp tục",
  "send": "Gửi",
  "resend": "Gửi lại",
  "sendCodeErrorTip": "Gửi mã thất bại: {error}",
  "sendEmailTips": "Chúng tôi đã gửi mã xác minh đến email của bạn",
  "verificationCode": "Mã xác minh",
  "codePlaceholder": "Nhập mã",
  "wallet": "Ví",
  "otherLoginMethods": "Phương thức đăng nhập khác",
  "login": "Đăng nhập",
  "user": "Người dùng",
  "loginTitle": "Đăng nhập / Đăng ký",
  "loginTips": "Bạn có thể sử dụng các phương thức sau",
  "passwordMinError": "Mật khẩu phải có ít nhất {length} ký tự",
  "passwordMatchError": "Hai mật khẩu không khớp",
  "passwordTitle": "Tạo mật khẩu",
  "passwordTips": "Vui lòng đặt mật khẩu để khôi phục ví",
  "password": "Mật khẩu",
  "passwordPlaceholder": "Nhập mật khẩu của bạn",
  "rePassword": "Xác nhận mật khẩu",
  "rePasswordPlaceholder": "Nhập lại mật khẩu",
  "recoverTitle": "Khôi phục ví",
  "recoverTips": "Nhập mật khẩu để khôi phục ví",
  "bindWith": "Liên kết với ví {name}",
  "loginWith": "Đăng nhập bằng ví {name}",
  "editUsernameTitle": "Chỉnh sửa tên người dùng",
  "setUsernameTitle": "Đặt tên người dùng",
  "username": "Tên người dùng",
  "usernamePlaceholder": "Nhập tên người dùng của bạn",
  "usernameValidError": "Tên chỉ được chứa chữ, số và ký tự",
  "usernameLengthError": "Tên phải dài ít nhất 2 ký tự",
  "confirm": "Xác nhận",
  "nextTime": "Lần sau",
  "setUsername": "Đặt tên người dùng",
  "disconnect": "Ngắt kết nối",
  "CEXBindTitle": "Liên kết API {type}",
  "CEXBindAttention": "Lưu ý:",
  "CEXBindTips1": "1. Vui lòng liên kết API với quyền chỉ đọc.",
  "CEXBindTips2": "2. API của bạn có thể đã lỗi thời. Tốt hơn là sử dụng API dài hạn.",
  "CEXBindTips3": "3. Chỉ có thể liên kết một API với cùng một sàn giao dịch tại một thời điểm.",
  "CEXBindApiKey": "Khóa API",
  "CEXBindApiSecretKey": "Khóa bí mật API",
  "CEXBindApiPassphrase": "Cụm mật khẩu API",
  "cancel": "Hủy",
  "walletLoading": "Dịch vụ ví đang tải",
  "tokenDetails": "Chi tiết Token",
  "tokenAmountMin": "Số tiền phải lớn hơn 0.",
  "tokenAmountMax": "Số dư không đủ.",
  "tokenAddressError": "Địa chỉ không hợp lệ.",
  "amount": "Số lượng",
  "amountPlaceholder": "Nhập số lượng.",
  "balance": "Số dư",
  "receiveTitle": "Địa chỉ ví nhận",
  "receivePlaceholder": "Nhập địa chỉ ví nhận.",
  "next": "Tiếp theo",
  "copied": "Đã sao chép",
  "receiveQrcode": "Nhận bằng cách quét mã QR",
  "copyAddress": "Sao chép địa chỉ",
  "tokenSmartContract": "Hợp đồng thông minh Token",
  "tokenSmartContractPlaceholder": "Nhập hợp đồng thông minh Token.",
  "tokenSymbol": "Ký hiệu Token",
  "tokenSymbolPlaceholder": "Nhập ký hiệu Token.",
  "tokenDecimals": "Số thập phân",
  "tokenDecimalsPlaceholder": "Nhập số thập phân.",
  "import": "Nhập",
  "receive": "Nhận",
  "customizedToken": "Token tùy chỉnh",
  "noMoreRecords": "Không còn bản ghi nào ở đây!",
  "noRecords": "Không có bản ghi nào ở đây!",
  "close": "Đóng",
  "back": "Quay lại",
  "importSuccess": "Nhập Token thành công",
  "importFail": "Không thể nhập Token",
  "changeNetwork": "Thay đổi mạng",
  "approveSuccess": "Phê duyệt thành công",
  "Approve": "Phê duyệt",
  "noFriends": "Chưa có bạn bè",
  "noRequests": "Chưa có yêu cầu nào",
  "noMore": "Không còn nữa",
  "Remove": "Xóa",
  "removeSuccess": "Xóa thành công"

}